import {useAuth} from "../../../context";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useGetJson, usePostJson} from "../../../hooks";
import {ChannelMap, EncodeMap, endpoints, radiosAdc, regex} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, Form, Modal, Stack} from "react-bootstrap";
import {AdminUserAlert, ColumnizeText, OurAlert, PageTitle, PasswordButton, SelectText, SingleText, SingleToggleText, ToggleText} from "../../_components";
import {Formik, Form as FormikForm, useFormikContext} from "formik";
import {WhiteCard} from "../_components/WhiteCard";

export function AddEditStreamSender() {
    const {userId, authToken} = useAuth()
    const {uid, did, sid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (sid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location])

    const edit = sid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(sid === "new" ? null : endpoints.event.get(sid), authToken?.jwt)
    const event = ev?.data
    const config2 = event?.config2

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.add(did), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(sid), authToken?.jwt)

    function createUri(schema, user, pass, host, port, path) {
        let auth
        if (user && pass) {
            auth = `${user}:${pass}@`
        } else if (user) {
            auth = `${user}@`
        } else {
            auth = ""
        }
        const pathname = path[0] !== "/" ? "/" + path : path
        return `${schema}://${auth}${host}:${port}${encodeURI(pathname)}`
    }

    const rawUri = typeof config2?.uri === "string" ? config2.uri : ""
    const isIcecast = rawUri.startsWith("icecast://")
    const isShoutcast = rawUri.startsWith("shoutcast://")

    const uriSchema = isIcecast ? "icecast" : isShoutcast ? "shoutcast" : "icecast"
    const isValidUri = (isIcecast || isShoutcast) && rawUri.length > uriSchema.length + 3
    const parsedUri = isValidUri
        ? new URL(rawUri.replace(/^(icecast|shoutcast):\/\//, "http://"))
        : undefined

    const validationSchema = yup.object().shape({
        schema: yup.string().required("Schema is required"),
        username: yup.string(),
        password: yup.string(),
        host: yup.string().required("Hostname is required").test("is-valid-server-or-ip", "Invalid format. Expected a domain (e.g., example.com) or an IP address (e.g., 192.168.1.1).", (value) => {
            return regex.server_pattern.test(value) || regex.ip_server_pattern.test(value);
        }),
        port: yup.number().typeError("Port must be a valid number").required("Port is required").min(1024, "Port must be at least 1024")
            .max(65535, "Port must be at most 65535"),
        mount: yup.string().required("Mountpoint is required"),
        timeout: yup.number().typeError("Timeout must be a valid number").required("Timeout is required").min(15, "Timeout must be at least 15")
            .max(120, "Timeout must be at most 120"),
        protocol: yup.string().required("Protocol is required"),
        name: yup.string(),
        adv: yup.string(),
        description: yup.string(),
        genre: yup.string(),
        web: yup.string(),
    })

    const initialValues = {
        // Replaced by URI
        schema: uriSchema || "icecast",
        username: parsedUri?.username || "",
        password: parsedUri?.password || "",
        host: parsedUri?.hostname || "",
        port: parsedUri?.port || "",
        mount: parsedUri?.pathname?.replace(/^\//, "") || "",
        //
        timeout: config2?.timeout || 15, // min 15 max 120 sec
        protocol: config2?.protocol || "tls",
        // Radio
        name: config2?.name || "",
        adv: config2?.adv || "private",
        description: config2?.description || "",
        genre: config2?.genre || "",
        web: config2?.web || "",
        // Encoding
        encoding: config2?.encoding == null ? 6 : config2.encoding,
        ch: config2?.ch == null ? 1 : config2.ch,
        qlt: config2?.qlt == null ? 1 : config2.qlt,
        sr: config2?.sr == null ? 44100 : config2.sr ,
        br: config2?.br == null ? 192 : config2.br,
        adc: config2?.adc == null ? 0 : config2.adc,
        gain: config2?.gain == null ? 1024 : config2.gain,
        autogain: config2?.autogain == null ? 0 : config2.autogain,
    }

    function handleOnSubmit(values, action) {
        const uri = createUri(values.schema, values.username, values.password, values.host, values.port, values.mount)
        const payload = {...location.state, name: location.state?.name || event?.name, sender: {...values, uri: uri}}
        if (edit) {
            submitFormEdit(payload, json => {
                action.setStatus('Something went wrong. Please try again.')
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            submitFormAdd(payload, jsonTime => {
                action.setStatus('Something went wrong. Please try again.')
                action.setSubmitting(false)
                navigate(location.state.steps[2])
            })
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }

    // const backTo = -1
    const backTo = () => navigate(location.state?.steps[0], {state: location.state})

    return <Stack>
        <AdminUserAlert/>
        {/*<OurAlert variant="info" show={userId !== uid} msg={`Watch out, you are managing user ID ${uid}.`}/>*/}
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>

        <PageTitle title="Set Sender">{edit ? `Edit ${event?.name}` : `Add`}.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, status}) => (
                <FormikForm>

                    <SenderStreamForm/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        {status && <div className="text-danger">{status}</div>}
                        {/*<Button as={Link} variant="link" to={backTo}>Go back</Button>*/}
                        <Button variant="link" onClick={backTo}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{edit ? "Edit" : "Add"}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>
    </Stack>
}

export function SenderStreamForm() {
    const {values, setFieldValue} = useFormikContext()

    const radiosSchema = [
        {id: "icecast", name: "icecast", variant: "primary", disabled: false},
        {id: "shoutcast", name: "shoutcast", variant: "primary", disabled: false}
    ]

    const radioAdv = [
        {id: "private", name: "Private", variant: "secondary", disabled: false},
        {id: "public", name: "Public", variant: "primary", disabled: false}
    ]

    const radioProtocol = [
        {id: "tls", name: "TLS", variant: "outline-secondary", disabled: false, icon: "bi bi-lock"},
        {id: "plain", name: "Plain", variant: "outline-danger", disabled: false, icon: "bi bi-unlock"},
    ]

    function handleOnChange(id) {
        switch (id) {
            case 5:
                setFieldValue("qlt", 0)
                setFieldValue("sr", 48000)
                setFieldValue("br", 5)
                setFieldValue("ch", 1)
                break
            case 6 :
                setFieldValue("qlt", 1)
                setFieldValue("sr", 44100)
                setFieldValue("br", 192)
                setFieldValue("adc", 0)
                setFieldValue("ch", 1)
                break
            case 7 :
                setFieldValue("sr", 44100)
                setFieldValue("ch", 1)
                break
        }
    }

    return <>
        <WhiteCard>
            <div className="fs-5 fw-semibold">Stream to</div>

            <Stack direction="horizontal" className="d-flex align-items-center" gap={2}>
                <ToggleText name="schema" label="Schema" items={radiosSchema}/>
                <SingleText name="host" label="Hostname" maxLength={32} placeholder="altrabits.com" className="flex-grow-1"/>
                <SingleToggleText name="protocol" label="Protocol" items={radioProtocol}/>
            </Stack>

            <Stack direction="horizontal" className="d-flex align-items-center" gap={2}>
                <SingleText name="port" label="Port" placeholder="8080"/>
                <SingleText name="mount" label="Mountpoint" placeholder="mynewradio" className="flex-grow-1 mb-2"/>
                <SingleText name="timeout" label="Timeout" placeholder="15" postfix="sec"/>
            </Stack>

            <ColumnizeText className="">
                <SingleText name="username" label="Username" autoComplete="off"/>
                <PasswordButton name="password" label="Password" position="right" autoComplete="new-password"/>
            </ColumnizeText>
        </WhiteCard>

        <WhiteCard>
            <div className="fs-5 fw-semibold">Radio details</div>
            <div className="d-flex align-items-center gap-2">
                <SingleText name="name" label="Name" maxLength={32} className="flex-fill" placeholder="Altrabits Radio"/>
                <SingleToggleText name="adv" label="Advertise" items={radioAdv} className=""/>
            </div>
            <SingleText name="description" label="Description" maxLength={64} placeholder="Altrabits Music"/>
            <SingleText name="genre" label="Genre" maxLength={32} placeholder="Dance"/>
            <SingleText name="web" label="URL web" maxLength={64} placeholder="altrabits.com"/>
        </WhiteCard>

        <WhiteCard>
            <div className="fs-5 fw-semibold ">Stream encoding</div>
            <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="flex-fill">
                    <ToggleText name="encoding" label="" items={EncodeMap} fullspace wrap onChange={handleOnChange}/>
                </div>
                {values.encoding === 6 && <Mp3EncoderSettings/>}
                {values.encoding === 5 && <OggEncoderSettings/>}
                {values.encoding === 7 && <FlacEncoderSettings/>}
            </div>

            <GainSlider name="gain" label="Line-in gain" disabled={false}/>
            <GainSlider name="autogain" label="Line-in auto gain" disabled={values.gain !== 0}/>
        </WhiteCard>
    </>
}

function Mp3EncoderSettings() {
    const {values, setFieldValue} = useFormikContext()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const radiosQuality = [
        {id: 0, name: "Qlt", variant: "secondary", disabled: true},
        {id: 1, name: "VBR", variant: "primary", disabled: false},
        {id: 3, name: "CBR", variant: "primary", disabled: false}
    ]

    const encoderFormats =
        {
            0: { // mono
                48000: [56, 64, 80, 96, 112, 128, 160, 192, 224, 256],
                44100: [56, 64, 80, 96, 112, 128, 160, 192, 224, 256],
                32000: [32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192],
                24000: [24, 32, 40, 48, 56, 64, 80, 96, 112],
                22050: [24, 32, 40, 48, 56, 64, 80, 96, 112],
                16000: [24, 32, 40, 48, 56, 64, 80],
                12000: [24, 32, 40, 48, 56, 64],
                11025: [24, 32, 40, 48, 56, 64],
                8000: [8, 16, 24, 32, 40, 48]
            },
            1: { // stereo
                48000: [112, 128, 160, 192, 224, 256, 320],
                44100: [96, 112, 128, 160, 192, 224, 256, 320],
                32000: [80, 96, 112, 128, 160, 192, 224, 256],
                24000: [64, 80, 96, 112, 128, 144],
                22050: [56, 64, 80, 96, 112, 128],
                16000: [40, 48, 56, 64, 80, 96, 112, 128],
                12000: [32, 40, 48, 56, 64, 80, 96, 112, 128],
                11025: [32, 40, 48, 56, 64, 80, 96, 112, 128],
                8000: [8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112]
            }
        }

    const defaultBitrate = {
        48000: 224,
        44100: 192,
        32000: 112,
        24000: 96,
        22050: 80,
        16000: 64,
        12000: 56,
        11025: 56,
        8000: 32
    }

    useEffect(() => {
        setFieldValue("br", defaultBitrate[Number(values.sr)])
    }, [values.sr])

    return <>
        <Button variant="primary" onClick={handleShow}>
            Advanced
        </Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>MP3 Encoder Configuration</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <ColumnizeText>
                    <ToggleText name="ch" label="Channel" items={ChannelMap} fullspace/>
                    <ToggleText name="qlt" label="Bitrate" items={radiosQuality} fullspace/>
                </ColumnizeText>

                <ColumnizeText>
                    <SelectText name="sr" label="Samplerate (Hz)">
                        {Object.keys(encoderFormats[values.ch]).map(item => (
                            <option key={item} value={item}>{item} Hz</option>
                        ))}
                    </SelectText>

                    <SelectText name="br" label="Quality (kbps)">
                        {(encoderFormats[values.ch]?.[values.sr] || []).map(br => (
                            <option key={br} value={br}>{br} kbps</option>
                        ))}
                    </SelectText>
                </ColumnizeText>

                <ToggleText name="adc" label="ADC" items={radiosAdc} fullspace/>

            </Modal.Body>
        </Modal>
    </>
}

function OggEncoderSettings() {
    const {values, setFieldValue} = useFormikContext()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const radiosQuality = [
        {id: 0, name: "Qlt", variant: "primary", disabled: false},
        {id: 1, name: "VBR", variant: "secondary", disabled: true},
        {id: 3, name: "CBR", variant: "secondary", disabled: true}
    ]

    const encoderFormats =
        {
            0: { // mono
                8000: [6, 7, 9, 10, 12, 13, 16, 19, 22, 25, 28],
                16000: [7, 11, 14, 18, 21, 25, 31, 37, 43, 49, 55],
                48000: [37, 47, 57, 68, 78, 88, 99, 110, 122, 133, 144]
            },
            1: { // stereo
                16000: [10, 18, 26, 34, 42, 50, 65, 81, 96, 112, 127],
                48000: [53, 72, 91, 110, 129, 148, 185, 222, 259, 296, 333]
            }
        }

    const defaultBitrate = {
        8000: 5,
        16000: 5,
        48000: 5
    }

    useEffect(() => {
        setFieldValue("br", defaultBitrate[Number(values.sr)])
    }, [values.sr])

    return <>
        <Button variant="primary" onClick={handleShow}>
            Advanced
        </Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Ogg Vorbis Encoder Configuration</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <ColumnizeText>
                    <ToggleText name="ch" label="Channel" items={ChannelMap} fullspace/>
                    <ToggleText name="qlt" label="Bitrate" items={radiosQuality} fullspace/>
                </ColumnizeText>

                <ColumnizeText>
                    <SelectText name="sr" label="Samplerate (Hz)">
                        {Object.keys(encoderFormats[values.ch]).map(item => (
                            <option key={item} value={item}>{item} Hz</option>
                        ))}
                    </SelectText>

                    <SelectText name="br" label="Quality (0-10)" className="">
                        {(encoderFormats[values.ch]?.[values.sr] || []).map((br, index) => (
                            <option key={br} value={index}>{`${index} (${br} kbps)`}</option>
                        ))}
                    </SelectText>
                </ColumnizeText>

            </Modal.Body>
        </Modal>
    </>
}

function FlacEncoderSettings() {
    const {values, setFieldValue} = useFormikContext()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const encoderFormats =
        {
            0: { // mono
                48000: 768,
                44100: 706,
                32000: 512,
                24000: 384,
                22050: 353,
                16000: 256,
                12000: 192,
                11025: 176,
                8000: 128
            },
            1: { // stereo
                48000: 1536,
                44100: 1411,
                32000: 1024,
                24000: 768,
                22050: 706,
                16000: 512,
                12000: 384,
                11025: 353,
                8000: 256
            }
        }

    return <>
        <Button variant="primary" onClick={handleShow}>
            Advanced
        </Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>FLAC Encoder Configuration</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <ToggleText name="ch" label="Channel" items={ChannelMap} fullspace/>

                <ColumnizeText>
                    <SelectText name="sr" label="Samplerate (Hz)" className="">
                        {Object.keys(encoderFormats[values.ch]).map(item => (
                            <option key={item} value={item}>{item} Hz</option>
                        ))}
                    </SelectText>

                    <Form.Group>
                        <Form.Label column="">Quality (kbps)</Form.Label>
                        <Form.Control value={`Up to ${encoderFormats[values.ch][values.sr]} kbps`} readOnly plaintext className="rounded px-1"/>
                    </Form.Group>

                </ColumnizeText>

            </Modal.Body>
        </Modal>
    </>
}

function GainSlider({name, label, disabled}) {
    const {values, setFieldValue} = useFormikContext()
    const min = 0
    const max = 65535
    const step = 256
    const value = values[name]

    const onDecrease = () => {
        if (value > min) setFieldValue(name, value - step)
    }

    const onIncrease = () => {
        if (value < max) setFieldValue(name, value + step);
    };

    return (
        <Form.Group controlId={`${name}Id`} className="my-2">
            <Form.Label column="">{`${label} (${(value / 1024).toFixed(0)}x)`}</Form.Label>
            <Stack direction="horizontal" gap="2">
                <Button variant="outline-secondary" disabled={disabled} onClick={onDecrease}>
                    <i className="bi bi-dash-lg" style={{fontSize: "1.2em"}}/>
                </Button>
                <Form.Range
                    min={min}
                    max={max}
                    step={step}
                    disabled={disabled}
                    value={value}
                    onChange={(e) => setFieldValue(name, Number(e.target.value))}
                />
                <Button variant="outline-secondary" disabled={disabled} onClick={onIncrease}>
                    <i className="bi bi-plus-lg" style={{fontSize: "1.2em"}}/>
                </Button>
            </Stack>
        </Form.Group>
    );
}
